module.exports = __webpack_public_path__ + "img/fuel-plant.6eb15225.png";